// extracted by mini-css-extract-plugin
module.exports = {"quantitySelector":"PKyAU","quantitySelector-container":"jyned","quantity-btn":"zgeIJ","quantity-content":"ZFtWW"};